import { useSelector } from 'react-redux';
import { Route, Routes } from "react-router-dom";
import { ApplicationPaths, LoginActions, LogoutActions } from '../components/api-authorization/ApiAuthorizationConstants';
import AuthorizeRoute from '../components/api-authorization/AuthorizeRoute';
import { Login } from '../components/api-authorization/Login';
import Logout from '../components/api-authorization/Logout';
import MollieUpdate from '../components/mollie/MollieUpdate';
import DisabledDisplay from '../components/subcomponents/DisabledDisplay';
import { protectedRoutes } from './AppRoutes';
import LoadingDisplay from '../components/subcomponents/LoadingDisplay';

export default function AppRouter() {
    const { siomSettings } = useSelector((state) => state.settings.siom);
    const { pages } = useSelector((state) => state.settings.resource.navigation);

    return (
        <Routes>
            {/* PROTECTED ROUTES */}
            <Route element={<AuthorizeRoute />}>
                {protectedRoutes.map(({ path, element, requiredPage, customCheck }) => (
                    <Route
                        key={path}
                        path={path}
                        element={
                            pages.length === 0 ? (
                                <LoadingDisplay />
                            ) : (customCheck
                                ? customCheck(pages, siomSettings)
                                : requiredPage
                                    ? pages.includes(requiredPage)
                                    : true
                            ) ? (
                                element
                            ) : (
                                <DisabledDisplay />
                            )
                        }
                    />
                ))}
            </Route>

            {/* UNPROTECTED ROUTES */}
            <Route path="/betaling/:id" element={<MollieUpdate />} />

            {/* AUTHENTICATION ROUTES */}
            <Route path={ApplicationPaths.Login} element={<LoginAction name={LoginActions.Login} />} />
            <Route path={ApplicationPaths.LoginFailed} element={<LoginAction name={LoginActions.LoginFailed} />} />
            <Route path={ApplicationPaths.LoginCallback} element={<LoginAction name={LoginActions.LoginCallback} />} />
            <Route path={ApplicationPaths.Profile} element={<LoginAction name={LoginActions.Profile} />} />
            <Route path={ApplicationPaths.Register} element={<LoginAction name={LoginActions.Register} />} />
            <Route path={ApplicationPaths.LogOut} element={<LogoutAction name={LogoutActions.Logout} />} />
            <Route path={ApplicationPaths.LogOutCallback} element={<LogoutAction name={LogoutActions.LogoutCallback} />} />
            <Route path={ApplicationPaths.LoggedOut} element={<LogoutAction name={LogoutActions.LoggedOut} />} />

            {/* CATCH ALL ROUTE */}
            {pages.length > 0 && <Route path="*" element={<DisabledDisplay />} />}
        </Routes>
    );
}

function LoginAction({ name }) {
    return (<Login action={name}></Login>);
}

function LogoutAction({ name }) {
    return (<Logout action={name}></Logout>);
}
